// import React, { useCallback, useEffect, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { notification } from 'antd';
// import moment from 'moment';
// import { GlassCard, GlassButton, GlassInput, GlassModal, GlassStat, GlassProgress, GlassScoreRing } from '../glass';
// import {
//   useDailyJournalMutation,
//   useDashboardCalculationMutation,
//   useDeleteNoteMutation,
//   useLincfolioScoreMutation,
//   useSaveNoteMutation,
// } from '../slices/zerodhaApiSlice';
// import { useGetCecmasMutation, useGetSubMutation } from '../slices/usersApiSlice';
// import { useTrackVisitorMutation } from '../slices/visitApiSlice';
// import { setCalculations, setScore } from '../slices/dashboardSlice';
// import { setDailyjournal } from '../slices/dailyjournalSlice';
// import { DailyNetCumulativeChart, NetDailyPnlChart } from './Usercomp/PnlCharts';
// import TradeCalendar from './customeCalender';
// import MyEditor from './Usercomp/MyEditor';
// import DailyTradeDescription from './Usercomp/DailyTradeDescription';
// import AreaGredientChartY from './Usercomp/AreaGredientChartY';

// const FREE_PLAN_ID = '68a2df20b2bdf6c04cb5295b';
// const MONTHLY_TARGET = 50000; // change this number to set the monthly goal

// const rupee = (n) => `${n < 0 ? '-' : ''}₹${new Intl.NumberFormat('en-IN').format(Math.abs(Math.round(n)))}`;
// // same rank thresholds as the Profile page
// const level = (s) => (s < 25 ? 'Rookie' : s < 45 ? 'Novice' : s < 65 ? 'Skilled' : s < 85 ? 'Advanced' : 'Elite');

// const Mark = () => (
//   <svg width="26" height="14" viewBox="0 0 26 14" fill="none" stroke="var(--g-gold)" strokeWidth="2.4" aria-hidden="true">
//     <circle cx="7" cy="7" r="4.6" /><circle cx="19" cy="7" r="4.6" />
//   </svg>
// );

// const DashboardScreen = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { date } = useSelector((s) => s.date);
//   const { dashboard, score } = useSelector((s) => s.dashboard);
//   const { dailyjournal } = useSelector((s) => s.dailyjournal);

//   const [api, contextHolder] = notification.useNotification();
//   const [dailyJournal, { isLoading: isJournalLoading }] = useDailyJournalMutation();
//   const [saveNote, { isLoading: isSaveNoteLoading }] = useSaveNoteMutation();
//   const [deleteNote] = useDeleteNoteMutation();

//   const [
//     dashboardCalculation,
//     { isLoading: calcLoading },
//   ] = useDashboardCalculationMutation();

//   const [lincfolioScore] = useLincfolioScoreMutation();
//   const [getSub] = useGetSubMutation();
//   const [gcemas] = useGetCecmasMutation();
//   const [trackVisitor] = useTrackVisitorMutation();

//   const [currentPlan, setCurrentPlan] = useState(null);
//   const [admin, setAdmin] = useState(null);

//   const isPremium =
//     currentPlan != null && admin != null
//       ? (currentPlan.plan_id != FREE_PLAN_ID &&
//           currentPlan.status == 'active') ||
//         admin == true
//       : null;

//   useEffect(() => {
//     if (!sessionStorage.getItem('siteVisited')) {
//       trackVisitor();
//       sessionStorage.setItem('siteVisited', 'true');
//     }

//     getSub()
//       .unwrap()
//       .then((r) => setCurrentPlan(r.subscription))
//       .catch(() => setCurrentPlan({}));

//     gcemas()
//       .unwrap()
//       .then((r) => setAdmin(r.user))
//       .catch(() => setAdmin(false));

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const load = useCallback(async () => {
//     if (!date?.startDate || !date?.endDate) return;

//     const range = {
//       startDate: date.startDate,
//       endDate: date.endDate,
//     };

//     try {
//       dispatch(
//         setCalculations({
//           ...(await dashboardCalculation(range).unwrap()),
//         })
//       );
//     } catch (e) {
//       console.error(e);
//     }

//     try {
//       dispatch(
//         setScore({
//           ...(await lincfolioScore(range).unwrap()),
//         })
//       );
//     } catch (e) {
//       console.error(e);
//     }

//     try {
//       const res = await dailyJournal({
//         ...range,
//         page: 1,
//         pageSize: 1000,
//       }).unwrap();

//       if (res?.data) {
//         dispatch(setDailyjournal(res.data));
//       }
//     } catch (e) {
//       console.error(e);
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [date]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   // Dashboard calculations
//   const pnl = Number(dashboard?.netrealisedpnl) || 0;
//   const winPct = Number(dashboard?.winpercent) || 0;
//   const factor = dashboard?.factor;

//   const days = useMemo(
//     () =>
//       [...(dailyjournal?.results || [])]
//         .map((d) => ({
//           date: d._id,
//           pnl:
//             (Number(d.totalProfit) || 0) -
//             (Number(d.totalLoss) || 0),
//           trades: Number(d.totalTrades) || 0,
//         }))
//         .sort((a, b) =>
//           String(a.date).localeCompare(String(b.date))
//         ),
//     [dailyjournal]
//   );

//   const tradesLogged = days.reduce(
//     (n, d) => n + d.trades,
//     0
//   );

//   const bestDay = days.length
//     ? days.reduce((a, b) => (b.pnl > a.pnl ? b : a))
//     : null;

//   const worstDay = days.length
//     ? days.reduce((a, b) => (b.pnl < a.pnl ? b : a))
//     : null;

//   let streak = 0;

//   for (
//     let i = days.length - 1;
//     i >= 0 && days[i].pnl > 0;
//     i -= 1
//   ) {
//     streak += 1;
//   }

//   // each part is out of 300, so the sum is out of 900 -> divide by 9 for a 0-100 score
//   const total = score
//     ? Math.min(
//         100,
//         Math.round(
//           ((score.lincwinScore || 0) +
//             (score.lincavgwinlossScore || 0) +
//             (score.lincprofitfactorScore || 0)) /
//             9
//         )
//       )
//     : 0;

//   const goalPct = Math.max(
//     0,
//     Math.min(100, Math.round((pnl / MONTHLY_TARGET) * 100))
//   );

//   const dash = '—';

//   const gated = (v) =>
//     isPremium === null ? dash : isPremium ? v : 'Premium';

//   // ---- Day note popup (opened from the calendar) ----
//   const [modeldata, setModeldata] = useState({});
//   const [content, setContent] = useState('');
//   const [notetitle, setNotetitle] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // keep the popup fields in sync with the selected day
//   useEffect(() => {
//     if (modeldata) {
//       setNotetitle(modeldata?.note?.title || modeldata?.title || '');
//       setContent(modeldata?.note?.content || modeldata?.content || '');
//     }
//   }, [modeldata]);

//   const resetModal = () => {
//     setIsModalOpen(false);
//     setModeldata({});
//     setNotetitle('');
//     setContent('');
//   };

//   const handleOk = async () => {
//     try {
//       await saveNote({
//         _id: modeldata?._id,
//         trade_date: modeldata?.trade_date || modeldata?.date,
//         title: notetitle,
//         content: content,
//       }).unwrap();
//       api.success({ message: 'Note Saved!' });
//       resetModal();
//     } catch (err) {
//       api.error({ message: err?.data?.message || err.error });
//     }
//   };

//   const handleDeleteNote = async () => {
//     const tradeDate = modeldata?.trade_date || modeldata?.date;
//     if (!tradeDate) return;

//     await deleteNote(moment(tradeDate).format('YYYY-MM-DD'));

//     setNotetitle('');
//     setContent('');
//   };

//   const dayPnl = (modeldata?.totalProfit || 0) - (modeldata?.totalLoss || 0);

//   return (
//     <div className="glass-scope">
//       {contextHolder}

//       {/* Dashboard Header */}
//       <div className="gd-head">
//         <h1>Dashboard</h1>

//         {/* <GlassButton
//           variant="primary"
//           onClick={() => navigate('/ImportTrades')}
//         >
//           + Log Trade
//         </GlassButton> */}
//       </div>

//       {/* Dashboard Insight */}
//       <GlassCard className="gd-insight">
//         <Mark />

//         <p>
//           {tradesLogged
//             ? `${tradesLogged} trades logged in this period · win rate ${winPct.toFixed(0)}% · net ${rupee(pnl)}`
//             : 'No trades in this period yet. Import your trades to see insights.'}
//         </p>
//       </GlassCard>

//       {/* Statistics Cards */}
//       <div
//         className="glass-grid glass-grid--4"
//         style={{ marginTop: 14 }}
//       >
//         <GlassStat
//           label="Realised P&L"
//           value={calcLoading ? dash : rupee(pnl)}
//           tone={pnl > 0 ? 'gold' : undefined}
//         />

//         <GlassStat
//           label="Trade Win %"
//           value={calcLoading ? dash : `${winPct.toFixed(0)}%`}
//         />

//         <GlassStat
//           label="Profit Factor"
//           value={gated(factor != null ? factor : 'N/A')}
//         />

//         <GlassStat
//           label="Trades Logged"
//           value={tradesLogged}
//         />
//       </div>

//       {/* Main Dashboard Cards */}
//       <div className="gd-main">
//         <div className="gd-col">
//           {/* Lincfolio Score */}
//           <GlassCard>
//             <div className="gd-cardhead">
//               <h3 className="glass-title">
//                 Lincfolio Score
//               </h3>

//               <span className="gd-badge">
//                 ★ {level(total)}
//               </span>
//             </div>

//             {isPremium === false ? (
//               <span className="glass-muted">
//                 This feature is Premium
//               </span>
//             ) : (
//               <>
//                 <div className="gd-score">
//                   <GlassScoreRing
//                     value={total}
//                     size={120}
//                   />

//                   <div className="gd-score__bars">
//                     <GlassProgress
//                       label="Win %"
//                       value={Math.round(
//                         Number(score?.winpr) || 0
//                       )}
//                     />

//                     <GlassProgress
//                       label="Avg Win/Loss"
//                       value={Math.round(
//                         Number(score?.lincavgwinlossPercent) || 0
//                       )}
//                     />

//                     <GlassProgress
//                       label="Profit Factor"
//                       value={Math.round(
//                         Number(score?.lincprofitfactorPercent) || 0
//                       )}
//                     />
//                   </div>
//                 </div>

//                 <div className="gd-score__foot">
//                   {streak}-day streak
//                 </div>
//               </>
//             )}
//           </GlassCard>

//           {/* Best Day and Worst Day */}
//           <div className="gd-pair">
//             <GlassCard
//               variant="default"
//               className="glass-card--glow gd-trade gd-trade--best"
//             >
//               <div className="gd-trade__tag">
//                 ★ BEST DAY
//               </div>

//               <div className="gd-trade__name">
//                 {bestDay
//                   ? String(bestDay.date).slice(0, 10)
//                   : dash}
//               </div>

//               <div className="gd-trade__val">
//                 {bestDay ? rupee(bestDay.pnl) : dash}
//               </div>
//             </GlassCard>

//             <GlassCard className="gd-trade">
//               <div className="gd-trade__tag">
//                 WORST DAY
//               </div>

//               <div className="gd-trade__name">
//                 {worstDay
//                   ? String(worstDay.date).slice(0, 10)
//                   : dash}
//               </div>

//               <div className="gd-trade__val">
//                 {worstDay ? rupee(worstDay.pnl) : dash}
//               </div>
//             </GlassCard>
//           </div>
//         </div>

//         {/* Monthly Goal */}
//         <GlassCard>
//           <div className="gd-cardhead">
//             <h3 className="glass-title">
//               Monthly Goal
//             </h3>

//             <span
//               style={{
//                 color: 'var(--g-gold)',
//                 fontSize: 12,
//               }}
//             >
//               {goalPct}%
//             </span>
//           </div>

//           <div className="glass-progress__track">
//             <div
//               className="glass-progress__bar"
//               style={{ width: `${goalPct}%` }}
//             />
//           </div>

//           <div
//             className="glass-muted"
//             style={{ marginTop: 8 }}
//           >
//             Target {rupee(MONTHLY_TARGET)}
//           </div>
//         </GlassCard>
//       </div>

//       {/* P&L charts (each one is a full card: title, bars, footer) */}
//       <div
//         className="glass-grid"
//         style={{
//           gridTemplateColumns:
//             'repeat(auto-fit, minmax(min(100%, 380px), 1fr))',
//           gap: 16,
//           marginTop: 16,
//         }}
//       >
//         <DailyNetCumulativeChart data={days} />
//         <NetDailyPnlChart data={days} />
//       </div>

//       {/* Trade calendar (bottom of the dashboard) */}
//       <div style={{ marginTop: 16 }}>
//         <TradeCalendar
//           journalData={dailyjournal?.results || []}
//           onOpenNote={(data) => {
//             setModeldata(data);
//             setIsModalOpen(true);
//           }}
//         />
//       </div>

//       {/* Day note popup */}
//       <GlassModal
//         open={isModalOpen}
//         onClose={resetModal}
//         width={1000}
//         title={`${moment(modeldata?._id).format('ddd, D MMM, YYYY')}  ·  Realised P&L ₹ ${isJournalLoading ? 0 : dayPnl.toFixed(2)}`}
//         footer={
//           <>
//             <GlassButton onClick={resetModal}>Cancel</GlassButton>
//             <GlassButton variant="primary" disabled={isSaveNoteLoading} onClick={handleOk}>
//               {isSaveNoteLoading ? 'Saving…' : 'Save note'}
//             </GlassButton>
//           </>
//         }
//       >
//         <div className="glass-grid glass-grid--modal">
//           <AreaGredientChartY datal={isJournalLoading ? [] : modeldata.runningPnlArray} />
//           <DailyTradeDescription data={modeldata} />
//         </div>

//         <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '12px 0' }}>
//           <GlassButton variant="danger" onClick={handleDeleteNote}>Delete note</GlassButton>
//         </div>

//         <GlassInput
//           placeholder="Title"
//           value={notetitle}
//           onChange={(e) => setNotetitle(e.target.value)}
//         />
//         <div style={{ marginTop: 10 }}>
//           {isModalOpen && <MyEditor setContent={setContent} initialContent={content} />}
//         </div>
//       </GlassModal>
//     </div>
//   );
// };

// export default DashboardScreen;


import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import moment from 'moment';
import { GlassCard, GlassButton, GlassInput, GlassModal, GlassStat, GlassProgress, GlassScoreRing } from '../glass';
import {
  useDailyJournalMutation,
  useDashboardCalculationMutation,
  useDeleteNoteMutation,
  useLincfolioScoreMutation,
  useSaveNoteMutation,
} from '../slices/zerodhaApiSlice';
import { useGetCecmasMutation, useGetSubMutation } from '../slices/usersApiSlice';
import { useTrackVisitorMutation } from '../slices/visitApiSlice';
import { setCalculations, setScore } from '../slices/dashboardSlice';
import { setDailyjournal } from '../slices/dailyjournalSlice';
import { DailyNetCumulativeChart, NetDailyPnlChart } from './Usercomp/PnlCharts';
import TradeCalendar from './customeCalender';
import MyEditor from './Usercomp/MyEditor';
import DailyTradeDescription from './Usercomp/DailyTradeDescription';
import AreaGredientChartY from './Usercomp/AreaGredientChartY';

const FREE_PLAN_ID = '68a2df20b2bdf6c04cb5295b';
const MONTHLY_TARGET = 50000; // change this number to set the monthly goal

const rupee = (n) => `${n < 0 ? '-' : ''}₹${new Intl.NumberFormat('en-IN').format(Math.abs(Math.round(n)))}`;
// same rank thresholds as the Profile page
const level = (s) => (s < 25 ? 'Rookie' : s < 45 ? 'Novice' : s < 65 ? 'Skilled' : s < 85 ? 'Advanced' : 'Elite');

const Mark = () => (
  <svg width="26" height="14" viewBox="0 0 26 14" fill="none" stroke="var(--g-gold)" strokeWidth="2.4" aria-hidden="true">
    <circle cx="7" cy="7" r="4.6" /><circle cx="19" cy="7" r="4.6" />
  </svg>
);

const DashboardScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { date } = useSelector((s) => s.date);
  const { dashboard, score } = useSelector((s) => s.dashboard);
  const { dailyjournal } = useSelector((s) => s.dailyjournal);

  const [api, contextHolder] = notification.useNotification();
  const [dailyJournal, { isLoading: isJournalLoading }] = useDailyJournalMutation();
  const [saveNote, { isLoading: isSaveNoteLoading }] = useSaveNoteMutation();
  const [deleteNote] = useDeleteNoteMutation();

  const [
    dashboardCalculation,
    { isLoading: calcLoading },
  ] = useDashboardCalculationMutation();

  const [lincfolioScore] = useLincfolioScoreMutation();
  const [getSub] = useGetSubMutation();
  const [gcemas] = useGetCecmasMutation();
  const [trackVisitor] = useTrackVisitorMutation();

  const [currentPlan, setCurrentPlan] = useState(null);
  const [admin, setAdmin] = useState(null);

  const isPremium =
    currentPlan != null && admin != null
      ? (currentPlan.plan_id != FREE_PLAN_ID &&
          currentPlan.status == 'active') ||
        admin == true
      : null;

  useEffect(() => {
    if (!sessionStorage.getItem('siteVisited')) {
      trackVisitor();
      sessionStorage.setItem('siteVisited', 'true');
    }

    getSub()
      .unwrap()
      .then((r) => setCurrentPlan(r.subscription))
      .catch(() => setCurrentPlan({}));

    gcemas()
      .unwrap()
      .then((r) => setAdmin(r.user))
      .catch(() => setAdmin(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = useCallback(async () => {
    if (!date?.startDate || !date?.endDate) return;

    const range = {
      startDate: date.startDate,
      endDate: date.endDate,
    };

    try {
      dispatch(
        setCalculations({
          ...(await dashboardCalculation(range).unwrap()),
        })
      );
    } catch (e) {
      console.error(e);
    }

    try {
      dispatch(
        setScore({
          ...(await lincfolioScore(range).unwrap()),
        })
      );
    } catch (e) {
      console.error(e);
    }

    try {
      const res = await dailyJournal({
        ...range,
        page: 1,
        pageSize: 1000,
      }).unwrap();

      if (res?.data) {
        dispatch(setDailyjournal(res.data));
      }
    } catch (e) {
      console.error(e);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    load();
  }, [load]);

  // Dashboard calculations
  const pnl = Number(dashboard?.netrealisedpnl) || 0;
  const winPct = Number(dashboard?.winpercent) || 0;
  const factor = dashboard?.factor;

  const days = useMemo(
    () =>
      [...(dailyjournal?.results || [])]
        .map((d) => ({
          date: d._id,
          pnl:
            (Number(d.totalProfit) || 0) -
            (Number(d.totalLoss) || 0),
          trades: Number(d.totalTrades) || 0,
        }))
        .sort((a, b) =>
          String(a.date).localeCompare(String(b.date))
        ),
    [dailyjournal]
  );

  const tradesLogged = days.reduce(
    (n, d) => n + d.trades,
    0
  );

  const bestDay = days.length
    ? days.reduce((a, b) => (b.pnl > a.pnl ? b : a))
    : null;

  const worstDay = days.length
    ? days.reduce((a, b) => (b.pnl < a.pnl ? b : a))
    : null;

  let streak = 0;

  for (
    let i = days.length - 1;
    i >= 0 && days[i].pnl > 0;
    i -= 1
  ) {
    streak += 1;
  }

  // each part is out of 300, so the sum is out of 900 -> divide by 9 for a 0-100 score
  const total = score
    ? Math.min(
        100,
        Math.round(
          ((score.lincwinScore || 0) +
            (score.lincavgwinlossScore || 0) +
            (score.lincprofitfactorScore || 0)) /
            9
        )
      )
    : 0;

  const goalPct = Math.max(
    0,
    Math.min(100, Math.round((pnl / MONTHLY_TARGET) * 100))
  );

  const dash = '—';

  const gated = (v) =>
    isPremium === null ? dash : isPremium ? v : 'Premium';

  // ---- Day note popup (opened from the calendar) ----
  const [modeldata, setModeldata] = useState({});
  const [content, setContent] = useState('');
  const [notetitle, setNotetitle] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // keep the popup fields in sync with the selected day
  useEffect(() => {
    if (modeldata) {
      setNotetitle(modeldata?.note?.title || modeldata?.title || '');
      setContent(modeldata?.note?.content || modeldata?.content || '');
    }
  }, [modeldata]);

  const resetModal = () => {
    setIsModalOpen(false);
    setModeldata({});
    setNotetitle('');
    setContent('');
  };

  const handleOk = async () => {
    try {
      await saveNote({
        _id: modeldata?._id,
        trade_date: modeldata?.trade_date || modeldata?.date,
        title: notetitle,
        content: content,
      }).unwrap();
      api.success({ message: 'Note Saved!' });
      resetModal();
    } catch (err) {
      api.error({ message: err?.data?.message || err.error });
    }
  };

  const handleDeleteNote = async () => {
    const tradeDate = modeldata?.trade_date || modeldata?.date;
    if (!tradeDate) return;

    await deleteNote(moment(tradeDate).format('YYYY-MM-DD'));

    setNotetitle('');
    setContent('');
  };

  const dayPnl = (modeldata?.totalProfit || 0) - (modeldata?.totalLoss || 0);

  return (
    <div className="glass-scope">
      {contextHolder}

      {/* Dashboard Header */}
      <div className="gd-head">
        <h1>Dashboard</h1>

        {/* <GlassButton
          variant="primary"
          onClick={() => navigate('/ImportTrades')}
        >
          + Log Trade
        </GlassButton> */}
      </div>

      {/* Dashboard Insight */}
      <GlassCard className="gd-insight">
        <Mark />

        <p>
          {tradesLogged
            ? `${tradesLogged} trades logged in this period · win rate ${winPct.toFixed(0)}% · net ${rupee(pnl)}`
            : 'No trades in this period yet. Import your trades to see insights.'}
        </p>
      </GlassCard>

      {/* Statistics Cards */}
      <div
        className="glass-grid glass-grid--4"
        style={{ marginTop: 14 }}
      >
        <GlassStat
          label="Realised P&L"
          value={calcLoading ? dash : rupee(pnl)}
          tone={pnl > 0 ? 'gold' : undefined}
        />

        <GlassStat
          label="Trade Win %"
          value={calcLoading ? dash : `${winPct.toFixed(0)}%`}
        />

        <GlassStat
          label="Profit Factor"
          value={gated(factor != null ? factor : 'N/A')}
        />

        <GlassStat
          label="Trades Logged"
          value={tradesLogged}
        />
      </div>

      {/* Main Dashboard Cards */}
      <div className="gd-main">
        {/* Left column: Lincfolio Score */}
        <div className="gd-col">
          <GlassCard>
            <div className="gd-cardhead">
              <h3 className="glass-title">Lincfolio Score</h3>
              <span className="gd-badge">★ {level(total)}</span>
            </div>

            {isPremium === false ? (
              <span className="glass-muted">This feature is Premium</span>
            ) : (
              <>
                <div className="gd-score">
                  <GlassScoreRing value={total} size={120} />

                  <div className="gd-score__bars">
                    <GlassProgress
                      label="Win %"
                      value={Math.round(Number(score?.winpr) || 0)}
                    />

                    <GlassProgress
                      label="Avg Win/Loss"
                      value={Math.round(Number(score?.lincavgwinlossPercent) || 0)}
                    />

                    <GlassProgress
                      label="Profit Factor"
                      value={Math.round(Number(score?.lincprofitfactorPercent) || 0)}
                    />
                  </div>
                </div>

                <div className="gd-score__foot">{streak}-day streak</div>
              </>
            )}
          </GlassCard>
        </div>

        {/* Right column: Monthly Goal + small Best / Worst Day boxes */}
        <div className="gd-col">
          <GlassCard>
            <div className="gd-cardhead">
              <h3 className="glass-title">Monthly Goal</h3>

              <span style={{ color: 'var(--g-gold)', fontSize: 12 }}>
                {goalPct}%
              </span>
            </div>

            <div className="glass-progress__track">
              <div
                className="glass-progress__bar"
                style={{ width: `${goalPct}%` }}
              />
            </div>

            <div className="glass-muted" style={{ marginTop: 8 }}>
              Target {rupee(MONTHLY_TARGET)}
            </div>
          </GlassCard>

          <div className="gd-pair gd-pair--sm">
            <GlassCard
              variant="default"
              className="glass-card--glow gd-trade gd-trade--best gd-trade--sm"
            >
              <div className="gd-trade__tag">★ BEST DAY</div>

              <div className="gd-trade__name">
                {bestDay ? String(bestDay.date).slice(0, 10) : dash}
              </div>

              <div className="gd-trade__val">
                {bestDay ? rupee(bestDay.pnl) : dash}
              </div>
            </GlassCard>

            <GlassCard className="gd-trade gd-trade--sm">
              <div className="gd-trade__tag">WORST DAY</div>

              <div className="gd-trade__name">
                {worstDay ? String(worstDay.date).slice(0, 10) : dash}
              </div>

              <div className="gd-trade__val">
                {worstDay ? rupee(worstDay.pnl) : dash}
              </div>
            </GlassCard>
          </div>
        </div>
      </div>

      {/* P&L charts (each one is a full card: title, bars, footer) */}
      <div
        className="glass-grid"
        style={{
          gridTemplateColumns:
            'repeat(auto-fit, minmax(min(100%, 380px), 1fr))',
          gap: 16,
          marginTop: 16,
        }}
      >
        <DailyNetCumulativeChart data={days} />
        <NetDailyPnlChart data={days} />
      </div>

      {/* Trade calendar (bottom of the dashboard) */}
      <div style={{ marginTop: 16 }}>
        <TradeCalendar
          journalData={dailyjournal?.results || []}
          onOpenNote={(data) => {
            setModeldata(data);
            setIsModalOpen(true);
          }}
        />
      </div>

      {/* Day note popup */}
      <GlassModal
        open={isModalOpen}
        onClose={resetModal}
        width={1000}
        title={`${moment(modeldata?._id).format('ddd, D MMM, YYYY')}  ·  Realised P&L ₹ ${isJournalLoading ? 0 : dayPnl.toFixed(2)}`}
        footer={
          <>
            <GlassButton onClick={resetModal}>Cancel</GlassButton>
            <GlassButton variant="primary" disabled={isSaveNoteLoading} onClick={handleOk}>
              {isSaveNoteLoading ? 'Saving…' : 'Save note'}
            </GlassButton>
          </>
        }
      >
        <div className="glass-grid glass-grid--modal">
          <AreaGredientChartY datal={isJournalLoading ? [] : modeldata.runningPnlArray} />
          <DailyTradeDescription data={modeldata} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '12px 0' }}>
          <GlassButton variant="danger" onClick={handleDeleteNote}>Delete note</GlassButton>
        </div>

        <GlassInput
          placeholder="Title"
          value={notetitle}
          onChange={(e) => setNotetitle(e.target.value)}
        />
        <div style={{ marginTop: 10 }}>
          {isModalOpen && <MyEditor setContent={setContent} initialContent={content} />}
        </div>
      </GlassModal>
    </div>
  );
};

export default DashboardScreen;